<template>
  <v-dialog v-model="show" persistent>
    <v-card class="py-4 px-3" v-if="firstPanel">
      <v-layout mx-3 align-center column text-left>
        <img width="30%" src="../../assets/icons/icon-values.png" />
        <span class="pt-3 subheading font-weight-medium"
          >Seja bem-vindx à nossa Carteira Digital (eWallet UseCar GO)!</span
        >
        <span class="pt-4 body-2 font-weight-regular">
          O que já era bom ficou ainda melhor! Agora vc pode utilizar o seu
          carro de aluguel por hora pelo app pagando por meio de débito em
          conta. Para utilizar essa modalidade, é necessário depositar R$300,00
          para fins de caução. O caução tem o propósito de cobrir eventuais
          sinistros que ocorram durante a utilização do veículo (batidas,
          roubos, multas, etc.). Sendo assim, se vc pretende comprar R$50,00 de
          crédito para dirigir, por exemplo, será necessário antes ter
          caucionado o valor de R$300,00.
        </span>
      </v-layout>
      <v-layout mx-3 align-center column text-center>
        <img class="nextStep-icon" src="../../assets/icons/icon-step1.png" />
      </v-layout>
      <v-btn @click="nextPanel(2)" class="nextStep ma-0 w-100 mt-5">
        <span class="white--text font-weight-bold">PRÓXIMO</span>
      </v-btn>
    </v-card>

    <v-card class="py-4 px-3" v-if="secondPanel">
      <v-layout mx-3 align-center column text-left>
        <span class="pt-3 subheading font-weight-medium"
          >Mas não se preocupe, pois o seu dinheiro estará bem guardado conosco!
        </span>
        <div class="pt-4 body-2 font-weight-regular">
          No momento que você desejar*, basta solicitar o saque do valor do
          caução da sua carteira que, no máximo em 3 dias úteis, retornaremos
          esse valor para sua conta bancária**.
          <br />
          Só um detalhe: Após o saque do caução, um novo aluguel passará por
          todo esse processo! Logo, se vc é um usuário frequente e/ou pretende
          utilizar novamente o seu UseCar GO em breve, considere essa
          informação.
        </div>
      </v-layout>
      <v-layout mx-3 align-center column text-center>
        <img class="nextStep-icon" src="../../assets/icons/icon-step2.png" />
      </v-layout>
      <v-btn @click="nextPanel(3)" class="nextStep ma-0 w-100 mt-5">
        <span class="white--text font-weight-bold">PRÓXIMO</span>
      </v-btn>
    </v-card>

    <v-card class="py-4 px-3" v-if="thirdPanel">
      <v-layout mx-3 align-center column text-left>
        <div class="pt-4 body-2 font-weight-regular">
          Nossa eWallet, além de inclusiva, prática e segura, é também
          totalmente transparente e, por isso, nas reservas realizadas por meio
          dessa modalidade, sempre será exibida a prévia do valor final de sua
          reserva para que você sempre analise seu saldo e garanta existir
          capacidade de pagamento.
        </div>
        <div class="pt-4 body-2 font-weight-regular">
          *Para solicitação do saque do caução, é necessário não existir
          reservas futuras agendadas. **O reembolso de caução somente será
          realizado em contas bancárias de mesma titularidade do usuário
          solicitante.
        </div>
        <span class="pt-3 subheading font-weight-medium"
          >eWallet UseCar GO – Inclusiva, prática, segura e transparente.
        </span>
      </v-layout>
      <v-layout mx-3 align-center column text-center>
        <img class="nextStep-icon" src="../../assets/icons/icon-step3.png" />
      </v-layout>
      <v-btn
        @click="
          $emit('close');
          nextPanel(1);
        "
        class="nextStep ma-0 w-100 mt-5"
      >
        <span class="white--text font-weight-bold">LI E CONCORDO</span>
      </v-btn>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from 'moment';

export default {
  data() {
    return {
      firstPanel: true,
      secondPanel: false,
      thirdPanel: false,
    };
  },

  props: {
    show: Boolean,
    date: String,
  },

  methods: {
    async nextPanel(step) {
      this.firstPanel = step === 1;
      this.secondPanel = step === 2;
      this.thirdPanel = step === 3;
    },
  },
};
</script>

<style scoped>
.float {
  position: absolute;
  top: 5px;
  right: 5px;
}

.nextStep {
  background-color: var(--secondary-color) !important;
  margin-top: 20px !important;
}

.nextStep-icon {
  margin-top: 20px !important;
}
</style>
